import type { Mode } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/types";
import { TextBox } from "store/features/memeGenerator/types";

export const isColorActive = (color: string, textBox: TextBox, mode: Mode) =>
    mode === "text"
        ? textBox.fontColor === color
        : mode === "outline"
        ? textBox.outline?.color === color
        : textBox.shadow?.color === color;
